import { Link } from 'react-router-dom';
import Logout from '../buttons/Logout.jsx';
import ThemeSwitcher from '../utils/ThemeSwitcher.jsx';
import ROUTES from '../../routes/Routes.js';
import Systeminfo from '../utils/Systeminfo.jsx';

export default function NavbarActions({ isAuthenticated, user }) {
    if (!isAuthenticated) {
        return (
            <>
                <div className="ms-auto">
                    <Link to={ROUTES.LOGIN} className="nav-link text-decoration-none me-5">Acceder</Link>
                </div>
            </>
        );
    }

    const isAdmin = user?.roleid === 1;

    return (
        <ul className="navbar-nav mb-2 mb-lg-0">
            <li className="nav-item dropdown d-flex">
                <a className="nav-link dropdown-toggle" href="##" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="bi bi-gear-fill me-2"></i> Opciones
                </a>
                <ul className="dropdown-menu">
                    {isAdmin && (
                        <>
                            <li><Systeminfo /></li>
                            <hr className="dropdown-divider" />
                        </>
                    )}
                    <li><Logout /></li>
                </ul>
            </li>

            <li className="nav-item py-2 py-lg-1 col-12 col-lg-auto">
                <div className="vr d-none d-lg-flex h-100 mx-lg-2"></div>
                <hr className="d-lg-none my-2 text-white-50" />
            </li>
            <li>
                <ThemeSwitcher />
            </li>
        </ul>
    );
}